// extracted by css-extract-rspack-plugin
export default {"themedSkeletons":"themedSkeletons-ZBe_g3","fade":"fade-GYV386"};